import { useNavigationCheck } from './useNavigationCheck';

export const usePanelViewMode = () => {
	const {safeIsMachinesScreenCheck} = useNavigationCheck();
	const panelViewMode = !safeIsMachinesScreenCheck;

	return {panelViewMode};
}